import { useRootStore } from './useRootStore';

export function usePrizeStore() {
  const { prizeStore } = useRootStore();
  return prizeStore;
}
